import { Box } from '@branch-messenger/willow-ui'
import { FC } from 'react'

import { QuickAmountButton } from '../../styles'

type AdvanceQuickAmountsProps = {
  amount: number
  setAmount: (amount: string) => void
  maxAmount: number
}

export const AdvanceQuickAmounts: FC<AdvanceQuickAmountsProps> = ({
  amount,
  setAmount,
  maxAmount,
}) => {
  const quickAmounts = [
    {
      label: '$25',
      value: 2500,
    },
    {
      label: '$50',
      value: 5000,
    },
    {
      label: '$75',
      value: 7500,
    },
    {
      label: '$100',
      value: 10000,
    },
    {
      label: 'Max',
      value: maxAmount,
    },
  ]

  return (
    <Box $display="flex" $justify="space-between" $flexWrap $gap={2}>
      {quickAmounts.map(({ label, value }) => {
        const isActive = amount * 100 === value
        return (
          <QuickAmountButton
            type="button"
            disabled={value > maxAmount}
            variant="pill"
            color={isActive ? 'secondary' : 'tertiary'}
            key={value}
            $isActive={isActive}
            onClick={() => setAmount(`${value / 100}`)}
          >
            {label}
          </QuickAmountButton>
        )
      })}
    </Box>
  )
}
